import { useNavigate } from "react-router-dom";
import { DataState } from "../recoil/onboardingPromotionDataAtom";
import { useOnboardingPromotionData } from "./useOnboardingPromotionData";

interface UseOnboardingPageProps {
  pageKey: string;
  nextPageRoute?: string;
}

export function useOnboardingPromotionPage({
  pageKey,
  nextPageRoute,
}: UseOnboardingPageProps) {
  const navigate = useNavigate();
  const pageDataHook = useOnboardingPromotionData(pageKey);

  // 프로모션 온보딩은 서버 저장이 없으므로 단순 페이지 이동만 처리
  const handleNext = (_dataToSave?: DataState) => {
    if (nextPageRoute) {
      navigate(nextPageRoute);
    }
  };

  return {
    ...pageDataHook,
    handleNext,
  };
}